import { emailRegex, phoneRegex, amountRegex, integerRegex } from './regex';

export const generateRequiredRule = (fieldName) =>
  // Metodo para definir el campo como requerido
  ({ required: true, message: `Por favor ingresa el campo ${fieldName}` });

export const generateCommonRules = (fieldName) => [
  // Metodo para campos que comparten mismas validaciones string y 255 caracteres
  generateRequiredRule(fieldName),
  { max: 255, message: `El campo ${fieldName} debe tener como máximo 255 caracteres` },
];

export const passwordRule = [
  generateRequiredRule('contraseña'),
  { min: 8, message: 'El campo contraseña debe tener como mínimo 8 caracteres' },
  { max: 255, message: 'El campo contraseña debe tener como máximo 255 caracteres' },
];

export const emailRules = (fieldName = 'correo electrónico') => [
  generateRequiredRule(fieldName),
  { max: 50, message: `El ${fieldName} debe tener como máximo 50 caracteres` },
  { pattern: emailRegex, message: `El ${fieldName} debe tener un formato válido` },
];

export const emailNoRequiredRules = (fieldName = 'correo electrónico') => [
  { max: 50, message: `El ${fieldName} debe tener como máximo 50 caracteres` },
  { pattern: emailRegex, message: `El ${fieldName} debe tener un formato válido` },
];

export const generatePriceRules = (fieldName = 'precio de venta') => [
  generateRequiredRule(fieldName),
  {
    pattern: /^\d+(\.\d{1,6})?$/,
    message: `El ${fieldName} debe ser un número válido con hasta 6 decimales`,
  },
  ];

export const phoneRules = [
  generateRequiredRule('teléfono'),
  {
    pattern: phoneRegex,
    message:
      'El campo teléfono debe tener 8 o 10 dígitos, considera el formato 12345678, 1234567890, 12-34-56-78 ó 12-34-56-78-90',
  },
];

export const amountRules = (fieldName) => [
  generateRequiredRule(fieldName),
  {
    pattern: amountRegex,
    message: `Ingrese un número positivo válido para el campo ${fieldName}. Los decimales son opcionales`,
  },
];

export const amountNoRquiredRules = (fieldName) => [
  {
    pattern: amountRegex,
    message: `El campo ${fieldName} debe ser un número de hasta 9 dígitos, sin negativos y 2 decimales opcionales`,
  },
];

export const amountRulesWithMin = (fieldName, minValue) => [
  ...amountRules(fieldName),
  {
    validator: (_, value) => {
      if (!value || parseFloat(value) >= minValue) {
        return Promise.resolve();
      }
      return Promise.reject(new Error(`El campo ${fieldName} debe ser al menos ${minValue}`));
    },
  },
];

export const integerRules = (fieldName) => [
  generateRequiredRule(fieldName),
  {
    pattern: integerRegex,
    message: `El campo ${fieldName} solo debe contener dígitos`,
  },
];

export const integerRulesWithMin = (fieldName, minValue) => [
  ...integerRules(fieldName),
  {
    validator: (_, value) => {
      if (!value || parseFloat(value) >= minValue) {
        return Promise.resolve();
      }
      return Promise.reject(new Error(`El campo ${fieldName} debe ser de al menos ${minValue}`));
    },
  },
];

export const onlyNDigits = (fieldName, requiredLength) => [
  generateRequiredRule(fieldName),
  {
    validator: (_, value) => {
      const numeric = String(value || '').trim();

      if (/^\d+$/.test(numeric) && numeric.length === requiredLength) {
        return Promise.resolve();
      }

      return Promise.reject(new Error(`El campo ${fieldName} debe tener exactamente ${requiredLength} dígitos`));
    },
  },
];

export const onlyNumbersAndHyphens = (fieldName) => [
  generateRequiredRule(fieldName),
  {
    validator: (_, value) => {
      const input = String(value || '').trim();

      // Solo números y guiones, sin guión al inicio o final
      if (/^\d+(?:-\d+)*$/.test(input)) {
        return Promise.resolve();
      }

      return Promise.reject(new Error(`El campo ${fieldName} solo debe contener números y guiones medios`));
    },
  },
];

export const onlyNumbersLettersAndHyphens = (fieldName) => [
  generateRequiredRule(fieldName),
  {
    validator: (_, value) => {
      const input = String(value || '').trim();

      // Solo números y guiones, sin guión al inicio o final
      if (/^(?!-)[a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*$/.test(input)) {
        return Promise.resolve();
      }

      return Promise.reject(new Error(`El campo ${fieldName} solo debe contener letras, números y guiones medios`));
    },
  },
];

export const websiteRule = (fieldName = 'sitio web') => [
  generateRequiredRule(fieldName),
  {
    pattern: /^(https?:\/\/)?([\w-]+\.)+[\w-]{2,}(\/[\w-./?%&=]*)?$/,
    message: `Ingresa una URL válida para el ${fieldName}`,
  },
];

export const integerNoRquiredRules = (fieldName) => [
  {
    pattern: integerRegex,
    message: `El campo ${fieldName} debe ser un número de hasta 9 dígitos, sin decimales ni negativos`,
  },
];

export const characterLimitField = (fieldName) => [
  // Metodo para campos que comparten misma validacion de 255 caracteres
  { max: 255, message: `El campo ${fieldName} debe tener como máximo 255 caracteres` },
];

export const textareaCommonRules = (fieldName, size = 1000) => [
  // Metodo para campos que comparten mismas validaciones string y 1000 caracteres
  { max: size, message: `El campo ${fieldName} debe tener como máximo ${size} caracteres` },
];

export const textareaCommonRequiredRules = (fieldName, size = 1000) => [
  // Metodo para campos que comparten mismas validaciones string y 1000 caracteres
  generateRequiredRule(fieldName),
  { max: size, message: `El campo ${fieldName} debe tener como máximo ${size} caracteres` },
];

export const validatePassword = () => [
  generateRequiredRule('contraseña'),
  { min: 8, message: 'El campo contraseña debe tener como mínimo 8 caracteres' },
  { max: 255, message: 'El campo contraseña debe tener como máximo 255 caracteres' },
];

// Función para validar la confirmación de contraseña
export const validatePasswordConfirmation = (getFieldValue, passwordFieldName = 'password') => ({
  validator(_, value) {
    if (!value || getFieldValue(passwordFieldName) === value) {
      return Promise.resolve();
    }
    return Promise.reject(new Error('Las contraseñas no coinciden.'));
  },
});
